<div class="sso-container">
  <div class="loading-container">
    <div class="spinner"></div>
    
    <div *ngIf="step() === 'start'" class="status-message">
      <p>Initializing authentication...</p>
    </div>

    <div *ngIf="step() === 'authenticating'" class="status-message">
      <p>Redirecting to Microsoft...</p>
      <p class="loading-text">You will be redirected to your organization's sign-in page.</p>
    </div>

    <div *ngIf="step() === 'verifying'" class="status-message">
      <p>Verifying your credentials...</p>
      <p class="loading-text">Retrieving user information...</p>
    </div>
    
    <div class="error" *ngIf="error()">{{ error() }}</div>
  </div>
</div>


